import React, { useId } from "react";

import classnames from "classnames/bind";

import { COLOR } from "@CORE/constants";

import { CheckIcon } from "@VIEW/components/icons";

import styles from "./BasicCheckbox.module.scss";

const cx: CX = classnames.bind(styles);

function BasicCheckbox({
    checked, //
    disabled,
    onChange,
    renderLabel,
    ...attributes
}: Props) {
    const inputId = useId();

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (!disabled) {
            onChange(event.target.checked, event);
        }
    }

    return (
        <div className={cx("basic-checkbox")}>
            <label
                htmlFor={inputId}
                className={cx({
                    disabled,
                })}
            >
                <input
                    id={inputId}
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={handleChange}
                    {...attributes}
                />
                <div className={cx("checkbox-wrapper")}>
                    {checked && (
                        <CheckIcon
                            color={disabled ? COLOR["grey"] : COLOR["white"]}
                            size={12}
                        />
                    )}
                </div>
                <div className={cx("label-text")}>{renderLabel(checked, disabled || false)}</div>
            </label>
        </div>
    );
}

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
    checked: boolean;
    onChange: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
    renderLabel: (checked: boolean, disabled: boolean) => React.ReactNode;
}

export default BasicCheckbox;
